import { render, staticRenderFns } from "./noAccess.vue?vue&type=template&id=67a62126&"
import script from "./noAccess.vue?vue&type=script&lang=js&"
export * from "./noAccess.vue?vue&type=script&lang=js&"
import style0 from "./noAccess.vue?vue&type=style&index=0&id=67a62126&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports